var map = {
	"./bin/roam-bin-movement-list.vue": [
		"af5d",
		"bin-roam-bin-movement-list-vue"
	],
	"./bin/roam-bin-movement-v1.vue": [
		"45cf",
		"bin-roam-bin-movement-v1-vue"
	],
	"./bin/roam-bin-movement.vue": [
		"d6b2",
		"bin-roam-bin-movement-vue"
	],
	"./products/roam-product-list.vue": [
		"abf8",
		"products-roam-product-list-vue"
	],
	"./products/roam-product.vue": [
		"8171",
		"products-roam-product-vue"
	],
	"./sales/roam-despatch-order-list.vue": [
		"fc76",
		"sales-roam-despatch-order-list-vue"
	],
	"./sales/roam-despatch-order.vue": [
		"1f86",
		"sales-roam-despatch-order-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f4cd";
module.exports = webpackAsyncContext;